import * as React from 'react'
import styled from 'styled-components'
import { Color, Size } from '../../../constants/app.constant'

interface Props {
  onChange?: (e: React.SyntheticEvent) => void
  name?: string
  placeholder?: string
  type?: string
  value?: string | number
  maxLength?: number
  invalidMessage?: string
  className?: string
}

const InputText: React.SFC<Props> = (props: Props) => (
  <div>
    <StyledInputText {...props} isInvalid={!!props.invalidMessage} />
    <InvalidMessage>{props.invalidMessage}</InvalidMessage>
  </div>
)
const InvalidMessage = styled.p`
  color: ${Color.STATUS_COLOR.STATUS_1};
  margin-top: 10px;
  font-size: ${Size.FONT.SMALL}px;
`

const StyledInputText = styled.input<{ isInvalid: boolean }>`
  border: none;
  border-bottom: 1px solid ${Color.PALETTE_COLOR.VERY_LIGHT_GRAY};
  padding: 6px 0;
  font-size: ${Size.FONT.MIDDLE}px;
  width: 100%;

  &::placeholder {
    color: ${Color.PALETTE_COLOR.LIGHT_GRAY};
  }

  &:focus {
    outline-style: none;
    border-bottom: 1px solid ${Color.STATUS_COLOR.STATUS_3};
  }

  ${({ isInvalid }) =>
    isInvalid &&
    `border-bottom: 1px solid ${Color.STATUS_COLOR.STATUS_1};
  `};
`

export default InputText



// WEBPACK FOOTER //
// ./src/components/atoms/input-text/input-text.tsx